import {Injectable} from '@angular/core';
import {ThemeService} from '@core/utils/theme.service';

@Injectable({providedIn: 'root'})
export class SpatialCardVm {
    constructor() {}

    public getBasemapName(theme: string): string {
        return ThemeService.isDark(theme) ? 'streets-night-vector' : 'gray-vector';
    }

    public isEquivalent(val1: any, val2: any): boolean {
        if (val1 instanceof Object && val2 instanceof Object) {
            const val1props = Object.keys(val1);
            const val2props = Object.keys(val2);

            if (val1props.length !== val2props.length) return false;

            for (let i = 0; i < val1props.length; i++) {
                if (val1props[i] === 'enabled') continue;
                const val2Prop = val2props.find((item) => item === val1props[i]);
                if (!val2Prop) return false;

                if (!this.isEquivalent(val1[val2Prop], val2[val2Prop])) return false;
            }
            return true;
        }
        return val1 === val2;
    }
}
